import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ad5258d8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5258d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad5258d8')) {
      api.createRecord('ad5258d8', component.options)
    } else {
      api.reload('ad5258d8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ad5258d8&scoped=true", function () {
      api.rerender('ad5258d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bookClassPackage/index.vue"
export default component.exports